import './TermsAndConditions.scss';
import { useNavigate } from 'react-router-dom';
import { Smartphone, Briefcase, Crown, Megaphone, Target, UserCheck, ChevronRight } from 'lucide-react';

const documents = [
    {
        type: 'app',
        document: 'terms',
        kind: 'Terms',
        surfaceName: 'Mobile App',
        surfaceSubtitle: 'iOS & Android',
        icon: Smartphone,
    },
    {
        type: 'business',
        document: 'terms',
        kind: 'Terms',
        surfaceName: 'Business Panel',
        surfaceSubtitle: 'business.zona.miami',
        icon: Briefcase,
    },
    {
        type: 'zonavip',
        document: 'terms',
        kind: 'Terms',
        surfaceName: 'ZONA VIP',
        surfaceSubtitle: 'Premium members',
        icon: Crown,
        hidden: true,
    },
    {
        type: 'brandambassador',
        document: 'contract',
        kind: 'Contract',
        surfaceName: 'Brand Ambassador',
        surfaceSubtitle: 'Promoter partners',
        icon: Megaphone,
        hidden: true,
    },
    {
        type: 'advertiser',
        document: 'terms',
        kind: 'Terms',
        surfaceName: 'Ads Portal',
        surfaceSubtitle: 'getzona.app/ads',
        icon: Target,
    },
    {
        type: 'advertiser',
        document: 'content-policy',
        kind: 'Content Policy',
        surfaceName: 'Ads Portal',
        surfaceSubtitle: 'getzona.app/ads',
        icon: Target,
    },
    {
        type: 'promoter',
        document: 'contract',
        kind: 'Contract',
        surfaceName: 'Affiliate Portal',
        surfaceSubtitle: 'getzona.app/affiliates',
        icon: UserCheck,
    },
    {
        type: 'promoter',
        document: 'terms',
        kind: 'Terms',
        surfaceName: 'Affiliate Portal',
        surfaceSubtitle: 'getzona.app/affiliates',
        icon: UserCheck,
    },
];

function TermsAndConditions() {
    const navigate = useNavigate();
    const visible = documents.filter((d) => !d.hidden);

    return (
        <section className='legal-list'>
            <header className='legal-list__header'>
                <h2>Terms and Conditions</h2>
                <p>Select a surface to edit its agreement.</p>
            </header>

            <ul className='legal-list__items'>
                {visible.map((d) => {
                    const Icon = d.icon;
                    return (
                        <li key={`${d.type}-${d.document}`}>
                            <button
                                type='button'
                                className='legal-list__item'
                                onClick={() => navigate(`/legal/${d.type}/${d.document}`)}
                            >
                                <span className='legal-list__item-icon'>
                                    <Icon size={18} />
                                </span>
                                <span className='legal-list__item-text'>
                                    <span className='legal-list__item-title'>
                                        {d.surfaceName}
                                    </span>
                                    <span className='legal-list__item-sub'>
                                        {d.kind} · {d.surfaceSubtitle}
                                    </span>
                                </span>
                                <ChevronRight size={18} className='legal-list__item-chevron' />
                            </button>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}

export default TermsAndConditions;
